<template>
  <div>
    <Navbar />
    <div class="w-section page-header">
      <div
        data-ix="navbar-grow"
        class="page-header-overlay default"
      >
        <div class="w-container container">
          <h1
            data-ix="fade-in-on-load"
            class="page-header-title"
          >
            Our services
          </h1>
        </div>
      </div>
    </div>
    <ServiceList :services="services" />
    <div class="w-section section white stats">
      <div class="w-container container">
        <div class="w-row stats-row">
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                20
              </div>
              <div class="stats-title description">
                Years in business
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                500,000+
              </div>
              <div class="stats-title description">
                Users
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                $100M+
              </div>
              <div class="stats-title description">
                In transactions
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                9
              </div>
              <div class="stats-title description">
                team members
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Navbar from '@/components/TheNavbar'
import Footer from '@/components/TheFooter'
import ServiceList from '@/components/ServiceList'

export default {
  name: 'Services',
  components: {
    Navbar,
    Footer,
    ServiceList,
  },

  computed: {
    ...mapGetters({
      services: 'allServices',
    }),
  },

  mounted() {
    this.fetchServices()
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },

  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },

  methods: {
    ...mapActions(['fetchServices']),
  },
}
</script>
